import { Helmet } from "react-helmet";
import useState from "react-usestateref"; // see this line

import NewHead from "./NewHead";
import { Link } from "react-router-dom";
import WHATSAPP from "../../image/newLanding/landing-whatsapp.webp";
import TELEGRAM from "../../image/newLanding/landing-telegram.webp";
import MAIL from "../../image/newLanding/landing-mail.webp";
import PHONE from "../../image/newLanding/landing-phone.webp";
import ARROW from "../../image/newLanding/arrow.webp";
import CONTACTIMG from "../../image/newLanding/contact-temple.svg";
import CONTACTIMGTWO from "../../image/newLanding/contact-img.svg";
import CURVE from "../../image/newLanding/hero-curve.webp";
import Stakingcard from "./Stakingcard";
import httpService from "../../config/httpCall";
import { toastAlert } from "../../config/toastAlert";
import { sendcontactpageContacts } from "../../config/apiCall";
import { sendUnsubmitUserContacts } from "../../config/apiCall";
import Marquee from "react-fast-marquee";
import {
  blockchainImgData,
  industryCardData,
  sliderData,
  webSliderData,
} from "../../utils/data";
import IndustryCards from "./IndustryCards";
import PhoneInput from "react-phone-input-2";
import NewFooter from "./NewFooter";
import BlockchainLogo from "./BlockchainLogo";
import { useEffect, useRef } from "react";
import LandingTechStack from "./LandingTechStack";
import useInView from "./useInView";
import { text } from "@fortawesome/fontawesome-svg-core";

const Landing = () => {
  const [isReach, setIsReach] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [selectedPlatform2, setSelectedPlatform2] = useState("whatsApp");
  const [scrollY, setScrollY] = useState(0);
  const [isFooter, setIsFooter] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [colorChanged, setColorChanged] = useState(false);
  const [activeError, setActiveError] = useState(null);

  const [sectionRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [heroImgRef, heroImgRefInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const NewFormfooterValue2 = {
    newformfootermediumValue: "",
    newformfootermedium: "whatsApp",
    newformfootermessage: "",
    newformfootermobile: "",
    newformfooteruserName: "",
    newformfootermobilecode: "",
  };

  const [newValue2, setnewValue2] = useState(NewFormfooterValue2);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      setScrollY((scrollTop / scrollHeight) * 100);

      if (
        scrollTop + window.innerHeight >=
        document.documentElement.scrollHeight - 400
      ) {
        setIsFooter(true);
      } else {
        setIsFooter(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (heroImgRefInView) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [heroImgRefInView]);

  const handleReachClick = () => {
    setIsReach((prevReach) => !prevReach);
  };

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "whatsApp",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue, newValueref] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);
  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [newformmessageErr, setnewformmessageErr, newformmessageErrref] =
    useState(false);
  const [newformmobileErr, setnewformmobileErr, newformmobileErrref] =
    useState(false);
  const [newformuserNameErr, setnewformuserNameErr, newformuserNameErrref] =
    useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [validationErr, setvalidationErr, validationErrref] = useState("");
  const [platformInput, setPlatformInput, platformInputref] = useState("");

  const [NewFormNMobileCode, setNewFormNMobileCode] = useState();
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [NewFormcountry, setNewFormcountry] = useState();
  const hasSentData = useRef(false);

  useEffect(() => {
    const sendDataOnce = () => {
      if (!hasSentData.current) {
        sendDataToBackend();
        hasSentData.current = true;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendDataOnce();
      }
    };

    const handleBeforeUnload = (event) => {
      sendDataOnce();
      event.preventDefault();
      event.returnValue = "";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [newValue, selectedPlatform2, platformInput, NewFormMobileValue]);

  const sendDataToBackend = async () => {
    try {
      const {
        newformuserName,
        newformmobilecode,
        newformmobile,
        newformmessage,
      } = newValueref.current;

      const userCountry = newValueref.current.NewFormcountry;
      const mediumDetail = platformInputref.current;
      // console.log("Data sent to backend starting *.*.*");

      if (
        newformuserName ||
        userCountry ||
        newformmobilecode ||
        newformmobile ||
        mediumDetail ||
        newformmessage
      ) {
        // console.log("Data sent to backend starting enters.....");
        const obj = {
          userName: newValueref.current.newformuserName,
          userCountry: newValueref.current.NewFormcountry,
          userCountryCode: newValueref.current.newformmobilecode,
          userMobilrNum: newValueref.current.newformmobile,
          contactMedium: selectedPlatform2,
          mediumDetail: platformInputref.current,
          userMessage: newValueref.current.newformmessage,
        };
        // console.log("Data sent to backend", obj);
        var messageSent = await sendUnsubmitUserContacts(obj);
        // console.log("messageSent---->>", messageSent);
      }
    } catch (error) {
      // console.error("Error sending data:", error);
    }
  };

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    setNewFormNMobileCode(countryObj.dialCode);
    setNewFormcountry(countryObj.name);
    newValueref.current["newformmobilecode"] = countryObj.dialCode;
    newValueref.current["newformmobile"] = value;
    newValueref.current["NewFormcountry"] = countryObj.name;
    setSelectedPlatform2("whatsApp");
    setPlatformInput("");
    // validate(newValueref.current);
    validateNewFormMobile(value, countryObj.dialCode);
    console.log(newValueref.current);
  };

  const validateNewFormMobile = (mobileValue, dialCode) => {
    let error = {};
    const countryCodeLength = dialCode.length;
    const actualMobileLength = mobileValue.length - countryCodeLength;

    if (mobileValue.trim() === "") {
      setnewformmobileErr(true);
      error.newformmobile = "Mobile Number is a required field";
    } else if (actualMobileLength < 7) {
      setnewformmobileErr(true);
      error.newformmobile =
        "Invalid number, must be at least 7 digits excluding country code";
    } else {
      setnewformmobileErr(false);
    }

    setvalidationErr(error);
  };

  const validate = async (formData) => {
    try {
      var error = {};
      console.log(formData.newformmobilecode);
      console.log(
        formData.newformmobilecode.length,
        formData.newformmobile.trim()
      );

      const countryCodeLength = formData.newformmobilecode.length;

      const actualMobileLength =
        formData.newformmobile.length - countryCodeLength;

      if (formData.newformuserName.trim() === "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Name is a required field";
        setvalidationErr(error);
      } else if (formData.newformuserName.length < 3) {
        setnewformuserNameErr(true);

        error.newformuserName = "Invalid username, Must be 3-50 characters";
        setvalidationErr(error);
      } else {
        setnewformuserNameErr(false);
      }

      if (formData.newformmobile.trim() === "") {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile = "Mobile Number is a required field";
        setvalidationErr(error);
      } else if (actualMobileLength < 7) {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile =
          "Invalid number, Must be at least 7 digits excluding country code";
        setvalidationErr(error);
      } else {
        setnewformmobileErr(false);
      }

      if (
        (selectedPlatform2 === "email" && platformInputref.current === "") ||
        platformInputref.current.length == 0
      ) {
        // setnewformmobileErr(false);
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Contact Medium is a required field";
        setvalidationErr(error);
      } else if (
        selectedPlatform2 === "email" &&
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
          platformInputref.current
        )
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Invalid email format";
        setvalidationErr(error);
      } else if (
        ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
      ) {
        if (platformInputref.current.trim() === "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Contact Medium is a required field";
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "whatsApp" &&
          platformInputref.current.length < 7
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "skype" &&
          platformInputref.current.length < 5
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else if (platformInputref.current.length < 5) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else {
          // setnewformuserNameErr(false);
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (formData.newformmessage.trim() === "") {
        // setnewformmediumValueErr(false);
        setnewformmessageErr(true);
        error.newformmessage = "Message is a required field";
        setvalidationErr(error);
      } else if (formData.newformmessage.length < 3) {
        setnewformmessageErr(true);
        error.newformmessage = "Message must contain at least 3 characters";
        setvalidationErr(error);
      } else if (formData.newformmessage.length > 250) {
        setnewformmessageErr(true);
        error.newformmessage = "Message can't exceed 250 characters";
        setvalidationErr(error);
      } else {
        setnewformmessageErr(false);
      }

      setvalidationErr(error);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePlatformInputChange = (e) => {
    const value = e.target.value;
    setPlatformInput(value);

    let error = {};
    let hasError = false;

    // Basic validation
    if (!value) {
      error.newformmediumValue = "This field is required.";
      hasError = true;
    } else if (
      selectedPlatform2 === "email" &&
      !/^[^\s@]+@[^\s@]+\.(com)$/i.test(value)
    ) {
      error.newformmediumValue = "Invalid email format.";
      hasError = true;
    } else if (selectedPlatform2 === "whatsApp" && value.length < 7) {
      error.newformmediumValue =
        "Invalid number, Must be at least 7 digits excluding country code";
      hasError = true;
    } else if (
      ["telegram", "skype"].includes(selectedPlatform2) &&
      value.length < 5
    ) {
      error.newformmediumValue = `${selectedPlatform2} ID must be at least 5 characters.`;
      hasError = true;
    }

    setvalidationErr(error);
    setnewformmediumValueErr(hasError);

    // if (value && value.length > 0) {
    //   setnewformmediumErr(false);
    //   setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
    // } else {
    //   setnewformmediumErr(true);
    //   setvalidationErr((prev) => ({
    //     ...prev,
    //     newformmedium: "Must enter the field",
    //   }));
    // }
    // // newValueref.current.newformmessage = "";
    // validate(newValueref.current);
    // if (
    //   selectedPlatform2 === "email" &&
    //   !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
    // ) {
    //   validate(newValueref.current);
    // }
  };

  const handleKeyPress = (e, maxLength, type) => {
    if (
      e.target.value.length >= maxLength &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key)
    ) {
      e.preventDefault();
      return;
    }

    if (type === "email") {
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
      if (
        !validEmailChars.test(e.key) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "number") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      // Prevent space at the start
      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }

      // Allow only digits, plus symbol at the start, spaces in the middle, and control keys
      if (
        !/[0-9 ]/.test(e.key) &&
        !(e.key === "+" && cursorPosition === 0) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "text") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }
      if (
        value.length < maxLength ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        return;
      }

      e.preventDefault();
    }
  };

  const handlePlatformSelect = (e, platform) => {
    e.preventDefault();
    setSelectedPlatform2(platform);
    setPlatformInput("");
  };

  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;

      // Update form state
      let formData = { ...newValue, [name]: value };
      setnewValue(formData);

      // Validate only `newformmessage`
      if (name === "newformmessage") {
        let error = { ...validationErr };

        if (!value.trim()) {
          error.newformmessage = "Message is a required field";
          setnewformmessageErr(true);
        } else if (value.length < 3) {
          error.newformmessage = "Message must contain at least 3 characters";
          setnewformmessageErr(true);
        } else if (value.length > 250) {
          error.newformmessage = "Message can't exceed 250 characters";
          setnewformmessageErr(true);
        } else {
          delete error.newformmessage; // Remove error if valid
          setnewformmessageErr(false);
        }

        setvalidationErr(error);
      }

      // e.preventDefault();
      // const { name, value } = e.target;
      // let formData = { ...newValue, ...{ [name]: value } };
      // setnewValue(formData);
      // await validate(formData);

      // if (selectedPlatform2 && !platformInputref.current) {
      //   setnewformmediumValueErr(true);
      // } else {
      //   setnewformmediumValueErr(false);
      // }

      // if (name === "newformmessage") {
      //   if (!value.trim()) {
      //     setnewformmessageErr(true);
      //   } else {
      //     setnewformmessageErr(false);
      //   }
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const [buttonLoader, setbuttonLoader] = useState(false);

  const sendServiceContact = async (e) => {
    try {
      e.preventDefault();
      validate(newValueref.current);
      console.log(newValueref.current);
      console.log(
        newValueref.current.newformuserName,
        newformuserNameErrref.current,
        newformmessageErrref.current,
        newformmobileErrref.current,
        newformmediumValueErrref.current,
        newformmobilecodeErr,
        newValueref.current.newformmessage
      );

      if (
        newValueref.current.newformuserName !== "" &&
        newformuserNameErrref.current === false &&
        newformmessageErrref.current === false &&
        newformmobileErrref.current === false &&
        newformmediumValueErrref.current == false &&
        newformmobilecodeErr === false &&
        newValueref.current.newformmessage != ""
      ) {
        setbuttonLoader(true);

        newValueref.current.newformmedium = selectedPlatform2;
        newValueref.current.newformmediumValue = platformInputref.current;

        var obj = {
          apiUrl: httpService.sendServiceContactDetails,
          payload: newValueref.current,
        };
        var messageSent = await sendcontactpageContacts(obj);
        

        if (messageSent.status == true) {
          toastAlert("success", messageSent.Message);
          setbuttonLoader(false);
        } else {
          toastAlert("error", messageSent.Message);
          setbuttonLoader(false);
        }
        newValueref.current.newformuserName = "";
        newValueref.current.newformmessage = "";
        newValueref.current.newformmobile = "";
        newValueref.current.newformmobilecode = "";
        setNewFormMobileValue("");
        setPlatformInput("");
        setNewFormNMobileCode("");
        setNewFormcountry();
        handleNewFormMobile("", "", "", "");
      } else {
        validate(newValueref.current);
      }
    } catch (errr) {
      console.log("errr", errr);
      setbuttonLoader(false);
    }
  };

  const [count1, setCount1] = useState(70);
  const [count3, setCount3] = useState(20);

  const [intervalTime1, setIntervalTime1] = useState(20);
  const [intervalTime3, setIntervalTime3] = useState(20);

  const [counterRef, counterRefView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  useEffect(() => {
    if (!counterRefView) return;

    const updateCounter1 = () => {
      const target1 = 100;
      const increment1 = target1 / 150; // Faster increment value
      setCount1((prevCount) => {
        if (prevCount < target1) {
          return Math.min(Math.ceil(prevCount + increment1), target1);
        }
        return prevCount;
      });
      setIntervalTime1((prevInterval) => Math.max(prevInterval * 0.1, 1));
    };

    const updateCounter3 = () => {
      const target3 = 50;
      const increment3 = target3 / 150; // Faster increment value
      setCount3((prevCount) => {
        if (prevCount < target3) {
          return Math.min(Math.ceil(prevCount + increment3), target3);
        }
        return prevCount;
      });
      setIntervalTime3((prevInterval) => Math.max(prevInterval * 0.1, 1));
    };

    const intervalId1 = setInterval(updateCounter1, intervalTime1);
    const intervalId3 = setInterval(updateCounter3, intervalTime3);

    return () => {
      clearInterval(intervalId1);
      clearInterval(intervalId3);
    };
  }, [counterRefView, intervalTime1, intervalTime3]);

  return (
    <>
      {/* meta data */}
      <div>
        <Helmet>
          <title>Top Ai and Blockchain Development Company</title>
          <meta
            name="description"
            content="Beleaf Technologies is the best enterprise blockchain technology solution & services provider company from India. Our blockchain technology development are completely custom build for the betterment for your business needs."
          />
          <meta
            property="og:title"
            content="Beleaf Technologies - Blockchain Development Company & Service Provider"
          />
          <meta property="og:site_name" content="Beleaf Technologies" />
          <meta property="og:url" content="https://beleaftechnologies.com" />
          <meta
            property="og:description"
            content="Beleaf Technologies is the best enterprise blockchain technology solution & services provider company from India. Our blockchain technology development are completely custom build for the betterment for your business needs."
          />
          <meta
            name="keywords"
            content="Blockchain development, blockchain app development, blockchain consulting services, blockchain technology company, custom blockchain development,  enterprise blockchain technology development company, enterprise blockchain technology, enterprise blockchain development company, enterprise blockchain company, blockchain as services, blockchain app, Web Design and Development company, Enterprise Mobile App development company, Offshore Development Center, Big Data Solutions, AI Chatbot Development, Digital Marketing Agency, AR VR Development,blockchain app development company, blockchain software development company, private blockchain development company, best blockchain development company, blockchain app development services, blockchain software development services, blockchain development solutions, hire blockchain developer"
          />
          <meta property="og:type" content="website" />

          <meta name="twitter:card" content="summary" />

          <meta name="twitter:site" content="@BeleafTech" />
          <meta
            name="twitter:title"
            content="Beleaf Technologies - Blockchain Development Company &amp; Service Provider"
          />
          <meta
            name="twitter:description"
            content="Beleaf Technologies is the best enterprise blockchain technology solution &amp; services provider company from India. Our blockchain technology development are completely custom build for the betterment for your business needs."
          />
          <link
            rel="canonical"
            href="https://beleaftechnologies.com/"
            data-react-helmet="true"
          ></link>
          <meta name="twitter:image:alt" content="Beleaf Technologies" />
        </Helmet>
      </div>

      <div className="landingWrapper">
        <NewHead />

        <div
          className={`${!isReach ? "landingReachOut" : "landingReachOutLeft"}`}
        >
          <div className="landingReachOut__links">
            <div className="landingReachOut__links--wrapper">
              <a href="https://wa.me/7904323274" target="_blank">
                <img
                  src={WHATSAPP}
                  alt="World's No.1 Blockchain Development Company"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="landingReachOut__links--wrapper">
              <a href="https://telegram.me/BeleafSoftTech" target="_blank">
                <img
                  src={TELEGRAM}
                  alt="World's No.1 Blockchain Development Company"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="landingReachOut__links--wrapper">
              <a href="mailto:business@beleaftechnologies.com" target="_blank">
                <img
                  src={MAIL}
                  alt="World's No.1 Blockchain Development Company"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="landingReachOut__links--wrapper">
              <a href="tel:+91 80567 86622" target="_blank">
                <img
                  src={PHONE}
                  alt="World's No.1 Blockchain Development Company"
                  loading="lazy"
                />
              </a>
            </div>
          </div>

          <div className="vertical-text" onClick={handleReachClick}>
            {isReach ? (
              <span>
                <img
                  src={ARROW}
                  alt="World's No.1 Blockchain Development Company"
                  className="reachOutArrow"
                  loading="lazy"
                />
              </span>
            ) : (
              "Reach Out"
            )}
          </div>
        </div>

        <main className="landingMain">
          {/* hero */}
          <article className="primary__landing__container">
            <article className="hero-section">
              <div className="hero-parent">
                <div className="hero-overlay"></div>
                <div className="overlay-text">
                  <div className="text-overlay"></div>
                </div>

                <div className="hero-content">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="primary__hero--left">
                        <h1 className="primary__hero--title hero-title-mw">
                          Top Ai and Blockchain Development Company
                        </h1>
                        <p className="primary__hero--content">
                          {" "}
                          {/* Your premier partner in blockchain development services, 
                          Prediction market development like <a className="polyMrktCloneLinktxt" target="_blank" href={"https://www.beleaftechnologies.com/polymarket-clone-script"}>polymarket clone script</a>. We believe in using the power of 
                          blockchain to transform businesses and drive innovation. */}
                          Your premier partner in Ai & blockchain development services, We believe in using the power of  Ai and blockchain to transform businesses and drive innovation. Hire Ai engineers and Blockchain developers for your dream business.
                        </p>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="primary-landing-hero-btn re-hero-btn"
                        >
                          <div className="re-btn-txt">
                            Get Free Consultation
                          </div>{" "}
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="tag-list">
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {sliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {webSliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>{" "}
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {webSliderData
                                .slice()
                                .reverse()
                                .map((data) => {
                                  return (
                                    <div
                                      className="tag"
                                      key={data.sliderContent}
                                    >
                                      {data.sliderContent}
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-right-img"
                                        loading="lazy"
                                      />
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-bottom-img"
                                        loading="lazy"
                                      />
                                    </div>
                                  );
                                })}

                              <div></div>
                            </div>
                          </div>{" "}
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {webSliderData
                                .slice()
                                .sort((a, b) =>
                                  a.sliderContent.localeCompare(b.sliderContent)
                                )
                                .map((data) => {
                                  return (
                                    <div
                                      className="tag"
                                      key={data.sliderContent}
                                    >
                                      {data.sliderContent}
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-right-img"
                                        loading="lazy"
                                      />
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-bottom-img"
                                        loading="lazy"
                                      />
                                    </div>
                                  );
                                })}

                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {sliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {webSliderData
                                .slice() // Create a shallow copy of the array
                                .sort(
                                  (a, b) =>
                                    b.sliderContent.length -
                                    a.sliderContent.length
                                ) // Sort by content length, longest first
                                .map((data) => {
                                  return (
                                    <div
                                      className="tag"
                                      key={data.sliderContent}
                                    >
                                      {data.sliderContent}
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-right-img"
                                        loading="lazy"
                                      />
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-bottom-img"
                                        loading="lazy"
                                      />
                                    </div>
                                  );
                                })}

                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {webSliderData
                                .slice()
                                .sort(
                                  (a, b) =>
                                    a.sliderContent.length -
                                    b.sliderContent.length
                                )
                                .map((data) => {
                                  return (
                                    <div
                                      className="tag"
                                      key={data.sliderContent}
                                    >
                                      {data.sliderContent}
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-right-img"
                                        loading="lazy"
                                      />
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-bottom-img"
                                        loading="lazy"
                                      />
                                    </div>
                                  );
                                })}

                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {webSliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>{" "}
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {webSliderData
                                .slice()
                                .sort((a, b) =>
                                  a.sliderContent.localeCompare(b.sliderContent)
                                )
                                .map((data) => {
                                  return (
                                    <div
                                      className="tag"
                                      key={data.sliderContent}
                                    >
                                      {data.sliderContent}
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-right-img"
                                        loading="lazy"
                                      />
                                      <img
                                        src={data.sliderImg}
                                        alt="World's No.1 Blockchain Development Company"
                                        className="hero-bottom-img"
                                        loading="lazy"
                                      />
                                    </div>
                                  );
                                })}

                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {sliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>{" "}
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider">
                            <div className="inner">
                              {sliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <Marquee speed={40} autoFill>
                          <div className="loop-slider loop-transform">
                            <div className="inner">
                              {sliderData.map((data) => {
                                return (
                                  <div key={data.id} className="tag">
                                    {data.sliderContent}
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-right-img"
                                      loading="lazy"
                                    />
                                    <img
                                      src={data.sliderImg}
                                      alt="World's No.1 Blockchain Development Company"
                                      className="hero-bottom-img"
                                      loading="lazy"
                                    />
                                  </div>
                                );
                              })}
                              <div></div>
                            </div>
                          </div>
                        </Marquee>
                        <div className="loop-fade"></div>
                      </div>

                      <div className="loop-fade-web"></div>
                    </div>
                  </div>
                </div>

                <a
                  className="hero-curve-wrap"
                  href="#landing-footer"
                  ref={heroImgRef}
                >
                  <img
                    src={CURVE}
                    alt="World's No.1 Blockchain Development Company"
                  />
                </a>
              </div>
            </article>

            {/* <div>
              <motion.div
                className="circle"
                style={{
                  background: `conic-gradient(
                #1163fb ${scrollY}%,
                transparent ${scrollY}%
              )`,
                  display: isVisible ? "none" : "flex",
                }}
              >
                <div className="inner-content">
                  <span onClick={isFooter ? scrollToTop : scrollToFooter}>
                    {isFooter ? (
                      <span>
                        <i className="fa-solid fa-arrow-up"></i>
                      </span>
                    ) : (
                      <span>
                        <i className="fa-solid fa-arrow-down"></i>
                      </span>
                    )}
                  </span>
                </div>
              </motion.div>
            </div>
      */}
          </article>

          {/* guide */}
          <article className="primary__landing-content-container">
            <article className="landing__guide ">
              <div className="row">
                <div className="col-lg-6">
                  <div>
                    <h3 className="landing__subHeader">
                      Your Guide to the
                      <div className="landing__subHeader-clr">
                        Ai & Blockchain Business
                      </div>
                    </h3>
                    <p className="landing__subContent landing-w-93">
                      {" "}
                      {/* Beleaf Technologies is a leading blockchain development
                      service provider, specializing in creating advanced
                      blockchain solutions for businesses of all sizes. Our team
                      of experts is passionate about blockchain technology and
                      is dedicated to helping you support its potential to the
                      fullest. With years of experience and a deep understanding
                      of the blockchain. Our team of experts specialise in Prediction Market Development , <a target="_blank" href="https://www.beleaftechnologies.com/cryptocurrency-exchange-development-company">crypto exchange development company</a> , Blockchain Development, Ai Development, Game Development and more. we are your trusted partner in
                      directing the complexities of this extensive technology. */}
                      Beleaf Technologies is a leading blockchain and AI development company, helping startups and enterprises turn innovative ideas into powerful digital solutions. We specialize in building secure, scalable, and customized technology solutions that drive business growth and digital transformation. Our expertise includes AI Development, Blockchain Development, AI Agent Development, Generative AI, Prediction Market Development, Cryptocurrency Exchange Development, Game Development, and more. From AI-powered applications and intelligent automation to blockchain platforms and decentralized ecosystems, we deliver solutions tailored to your business goals. With a skilled development team and end-to-end technical expertise, we help businesses accelerate innovation and stay competitive. Partner with Beleaf Technologies to transform your vision into market-ready technology solutions.
                    </p>
                    {/* <Link to="/contact-us"> */}
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="mt-2 primary-landing-main-btn"
                    >
                      Get Quote{" "}
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                    {/* </Link> */}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="landing__guide--right" ref={counterRef}>
                    <div className="landing__guide--right-wrap">
                      <div className="landing__guide--img-wrap">
                        <img
                          src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776779265/landYourGuideImg_v2lqvp.webp"
                          alt="World's No.1 Blockchain Development Company"
                          loading="lazy"
                          className="landing__guide--img"
                        />
                      </div>

                      <div className="landing__guide-subCards subCardOne">
                        <div className="landing__guide-subCards-wrap">
                          <div className="landing__guide-subCards-img-wrap">
                            <img
                              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746624862/guide-subcardOne_n0mofi.webp"
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <div>
                            <h6 data-target={100}>{count1}+ </h6>
                            <p>Happy Clients</p>
                          </div>
                        </div>
                      </div>
                      <div className="landing__guide-subCards subCardTwo">
                        <div className="landing__guide-subCards-wrap">
                          <div>
                            <h6
                              className="clr__dark text-end"
                              data-target={100}
                            >
                              {count1}+
                            </h6>
                            <p className="clr__dark">Successful Projects</p>
                          </div>
                          <div className="landing__guide-subCards-img-wrap">
                            <img
                              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746624862/guide-subcardTwo_wahtpy.webp"
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="landing__guide-subCards subCardThree">
                        <div className="landing__guide-subCards-wrap">
                          <div className="landing__guide-subCards-img-wrap">
                            <img
                              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746624862/guide-subcardThree_ib4gnd.webp"
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <div>
                            <h6 data-target={50}>{count3}+</h6>
                            <p>Countries</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <img
                          src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746624862/guide-subcardOne-mask_pxqfdk.png"
                          alt="World's No.1 Blockchain Development Company"
                          loading="lazy"
                          className="mask__img"
                        />
                      </div>
                      <div>
                        <img
                          src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746624862/guide-subcardOne-crown_bgefct.webp"
                          alt="World's No.1 Blockchain Development Company"
                          loading="lazy"
                          className="crown__img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </article>

          {/* explore */}
          <div className="landing__explore--section">
            <article className="primary__landing-content-container">
              <article>
                <div>
                  <h3 className="landing__explore--subHeader">
                    Explore Our
                    <span className="explore__arrow-wrap ">
                      <img
                        src={require("../../image/newLanding/explore-head-img.webp")}
                        alt="World's No.1 Blockchain Development Company"
                      />
                    </span>
                    <div>
                      Services To{" "}
                      <span className="landing__subHeader-clr">
                        Drive Success.{" "}
                      </span>{" "}
                    </div>
                  </h3>
                </div>

                <Stakingcard />
              </article>
            </article>

            <div className="landing__section__divider-wrap">
              <div className="landing__section__divider">
                <p>More Than 100+ Services Have Done</p>
              </div>
            </div>

            {/* industry cards */}
            <article className="primary__landing-content-container ">
              <div className="landing__top">
                <h3 className="landing__explore--subHeader">
                  Industry-Specific
                  <div>
                    <span className="landing__subHeader-clr">Solutions. </span>{" "}
                  </div>
                </h3>
                <p className="landing__specific-content">
                  Advanced blockchain and tech solutions for industries like
                  finance, healthcare, and logistics. Find unique challenges and
                  improvise operational efficiency.
                </p>
              </div>
            </article>
            <div className="landing__industry-cards-wrap">
              <Marquee
                speed={70}
                autoFill
                pauseOnHover
                className="landing__industry-cards"
              >
                {industryCardData.map((industryCardData) => {
                  return (
                    <IndustryCards
                      key={industryCardData.id}
                      industryCardData={industryCardData}
                    />
                  );
                })}
              </Marquee>
            </div>

            <div className="landing__section__divider-wrap">
              <div className="landing__section__divider">
                <p>Solution To Eighteen Industries</p>
              </div>
            </div>

            {/* Blockchain Networks */}
            <article className="primary__landing-content-container ">
              <div className="landing__top">
                <h3 className="text-center landing__explore--subHeader">
                  Blockchain Networks
                  <div>
                    We{" "}
                    <span className="landing__subHeader-clr">
                      {" "}
                      Specialize In.
                    </span>{" "}
                  </div>
                </h3>
              </div>

              <div className="landing__blockchain-img-wrapper">
                {blockchainImgData.map((blockchainNetworkLogo) => {
                  return (
                    <BlockchainLogo
                      key={blockchainNetworkLogo.id}
                      imgData={blockchainNetworkLogo}
                    />
                  );
                })}
              </div>
            </article>
            <div className="landing__section__divider-wrap">
              <div className="landing__section__divider">
                <p>Specialized In 20+ Networks</p>
              </div>
            </div>

            {/* techstack */}
            <LandingTechStack />

            {/* gateway */}
            <div className="landing__gateway" ref={sectionRef}>
              <p>Start Your Innovation Today!</p>
              <h6
                className={`${
                  inView ? "text-animate text-animate-inview" : "text-animate"
                }`}
              >
                Your Gateway to Success <div>Starts Here</div>
              </h6>
              <a href="/contact-us">
                <button className="mt-3 primary-landing-main-btn">
                  Get Started
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </a>
            </div>

            {/* get in touch */}
            <div>
              <div className="pr-contact-wrap-outer">
                <div className="pr-contact-wrap primary__landing-content-container">
                  <div className="pr-ct-details">
                    <span>
                      <i className="fa-brands fa-whatsapp"></i>
                    </span>
                    <span>+91 79043 23274</span>
                  </div>
                  <div className="pr-ct-details">
                    <span>
                      <i className="fa-regular fa-paper-plane"></i>
                    </span>
                    <span>@BeleafSoftTech</span>
                  </div>
                  <div className="pr-ct-details">
                    <span>
                      <i className="fa-regular fa-envelope"></i>
                    </span>
                    <span>business@beleaftechnologies.com</span>
                  </div>
                  <div className="pr-ct-details">
                    <span>
                      <i className="bi bi-telephone"></i>
                    </span>
                    <span>+91 80567 86622</span>
                  </div>
                </div>
              </div>

              <article className="primary__landing-content-container ">
                <div className="primary-get-in-touch">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="landing__contact">
                        <div>
                          <h5 className="landing__contact-title">
                            Get In Touch
                          </h5>
                          <p className="landing__contact-subContent">
                            We're here to assist you. Contact us for tailored
                            solutions to elevate your business.
                          </p>
                        </div>
                        <div className="landing__contact--address">
                          {/* <div className="landing__contact--address-wrap contact-primary-opacity">
                            <img
                              src={CONTACTIMGTWO}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                            <div className="landing__contact--address-info">
                              <h6>India - Thane</h6>
                              <p>
                                12, 4th floor Krishnasthal CHS, Mira Gaon Mira
                                Road East, Thane, Maharastra, <br /> Postal Code
                                - 401107, India.
                              </p>
                            </div>
                          </div> */}

                          <div className="landing__contact--address-wrap contact-opacity">
                            <img
                              src={CONTACTIMG}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                            <div className="landing__contact--address-info">
                              <h6>India - Madurai</h6>
                              <p>
                                5/24, Bharathiyar 7th street, S.S.Colony
                                Madurai, Tamil Nadu, <br /> Postal Code - 625
                                016, India.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="landing__contact--form landing_cnt_ov_hidden">
                        <form>
                          <h4 className="landing__contact--form-title">
                            Your Details
                          </h4>

                          <div className="mt-4">
                            <label htmlFor="form-name">Name</label> <br />
                            <input
                              type="text"
                              id="form-name"
                              placeholder="Enter your name"
                              className="landing__form-input margin-bottom-land"
                              name="newformuserName"
                              autoComplete="off"
                              value={newformuserName}
                              max="50"
                              maxLength="50"
                              // onChange={handleNewFormChange}
                              // onKeyPress={(e) => handleKeyPress(e, 50, "text")}
                              onChange={(e) => {
                                const value = e.target.value;
                                setnewValue((prev) => ({
                                  ...prev,
                                  newformuserName: value,
                                }));

                                if (value.trim() === "") {
                                  setnewformuserNameErr(true);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName: "Name is a required field",
                                  }));
                                } else if (value.length < 3) {
                                  setnewformuserNameErr(true);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName:
                                      "Invalid username, Must be 3-50 characters",
                                  }));
                                } else {
                                  setnewformuserNameErr(false);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName: "",
                                  }));
                                }
                              }}
                              onKeyPress={(e) => handleKeyPress(e, 50, "text")}
                            />
                            {newformuserNameErrref.current &&
                            newformuserNameErrref.current === true ? (
                              <div className="text-danger font_error_newch">
                                {" "}
                                {validationErrref.current.newformuserName}{" "}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="mt-4">
                            <label htmlFor="mobile">Mobile Number</label> <br />
                            <PhoneInput
                              country={"us"}
                              value={NewFormMobileValue}
                              inputProps={{
                                name: "phonenumber",
                                required: true,
                              }}
                              autoComplete="off"
                              className="form-phone landing__form-input margin-bottom-land"
                              onChange={(
                                value,
                                countryObj,
                                e,
                                formattedValue
                              ) =>
                                handleNewFormMobile(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                )
                              }
                              // onBlur={(e) => handleBlur(e)}
                            />
                            {newformmobileErrref.current &&
                            newformmobileErrref.current === true ? (
                              <div className="text-danger font_error_newch">
                                {validationErrref.current.newformmobile}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="mt-4">
                            <label htmlFor="form-contact">Contact Medium</label>{" "}
                            <br />
                            <div className="form-contact-medium">
                              <button
                                type="button"
                                className="dropdown-toggle landing__form-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {selectedPlatform2 == "whatsApp" ? (
                                  <i className="fa-brands fa-whatsapp"></i>
                                ) : selectedPlatform2 == "telegram" ? (
                                  <i className="fa-brands fa-telegram"></i>
                                // ) : selectedPlatform2 == "skype" ? (
                                //   <i className="fa-brands fa-skype"></i>
                                ) : selectedPlatform2 == "email" ? (
                                  <i
                                    className="fa fa-envelope"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="dropdown-menu landing__form-drop-menu">
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "whatsApp")
                                  }
                                >
                                  <i className="fa-brands fa-whatsapp"></i>
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "telegram")
                                  }
                                >
                                  <i className="fa-brands fa-telegram"></i>
                                </a>
                                {/* <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "skype")
                                  }
                                >
                                  <i className="fa-brands fa-skype"></i>
                                </a> */}
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "email")
                                  }
                                >
                                  <i
                                    className="fa fa-envelope"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>

                              {selectedPlatform2 && (
                                <input
                                  type="text"
                                  className="landing__contact-medium-input"
                                  placeholder={`Enter your ${selectedPlatform2} ${
                                    selectedPlatform2 == "email"
                                      ? "Address"
                                      : selectedPlatform2 === "whatsApp"
                                      ? "number"
                                      : "number / ID"
                                  }`}
                                  maxLength={
                                    selectedPlatform2 === "email"
                                      ? 250
                                      : selectedPlatform2 === "whatsApp"
                                      ? 15
                                      : 32
                                  }
                                  value={platformInputref.current}
                                  autoComplete="off"
                                  onChange={handlePlatformInputChange}
                                  onKeyPress={(e) =>
                                    handleKeyPress(
                                      e,
                                      selectedPlatform2 === "email"
                                        ? 250
                                        : selectedPlatform2 === "whatsApp"
                                        ? 15
                                        : 32,
                                      selectedPlatform2 === "email"
                                        ? "email"
                                        : selectedPlatform2 === "whatsApp"
                                        ? "number"
                                        : "text"
                                    )
                                  }
                                  // onBlur={(e) => handleBlur(e)}
                                />
                              )}
                            </div>
                            {newformmediumValueErrref.current &&
                            newformmediumValueErrref.current === true ? (
                              <span className="text-danger font_error_newch">
                                {validationErrref.current.newformmediumValue}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="mt-4">
                            <label htmlFor="message">
                              Tell Us About Your Project
                            </label>
                            <br />
                            <textarea
                              id="message"
                              placeholder="Message"
                              className="landing__form-input landing-textarea landing__form-input margin-bottom-land"
                              rows="5"
                              name="newformmessage"
                              value={newformmessage}
                              max="250"
                              maxLength="250"
                              autoComplete="off"
                              onChange={handleNewFormChange}
                              onKeyPress={(e) => handleKeyPress(e, 250, "text")}
                              // onBlur={(e) => handleBlur(e)}
                            ></textarea>

                            {newformmessageErrref.current == true ? (
                              <div className="text-danger font_error_newch">
                                {validationErrref.current.newformmessage}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="text-center mt-4">
                            {buttonLoader == true ? (
                              <button className="explore__card-btn" disabled>
                                loading....
                                <span className="mx-2 right-arr">
                                  <i className="fa-solid fa-arrow-right"></i>
                                </span>
                              </button>
                            ) : (
                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  className="explore__card-btn re-hero-btn nw-ct-btn"
                                  onClick={sendServiceContact}
                                >
                                  <div className="re-btn-txt">Submit</div>
                                  <span className="mx-2 right-arr">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                        </form>
                        <div className="landing__contact-fade"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </main>

        {/* footer */}
        <article id="landing-footer">
          <NewFooter />
        </article>

        {/* footer social links */}
        <div className="landing__footer-copyrights">
          <div className="primary__landing-content-container">
            <div className="landing__footer-copyrights-flex">
              <div className="landing__footer-privacy">
                <h6 className="landing__footer-copyrights-title">
                  Privacy policy | Terms & Conditions
                </h6>
              </div>
              <div>
                <h6 className="landing__footer-copyrights-title">
                  &copy; 2025 Beleaf Technologies All Rights Reserved
                </h6>
              </div>
              <div>
                <ul className="landing__footer-social-links">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/beleaf-technologies-blf/"
                    >
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/beleaftechnologies/"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://telegram.me/BeleafSoftTech"
                      target="_blank"
                    >
                      <img
                        src={TELEGRAM}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="mailto:business@beleaftechnologies.com"
                      target="_blank"
                    >
                      <i className="fa-regular fa-envelope"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/7904323274" target="_blank">
                      <i className="fa-brands fa-whatsapp"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://pin.it/3bOarDn">
                      <i className="fa-brands fa-pinterest-p"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Landing;
